import getPartCharge from './getPartCharge';
import updatePartCharge from './updatePartCharge';

export default {
	namespaced: true,
	state: {
		...getPartCharge.state,
		...updatePartCharge.state,
	},
	mutations: {
		...getPartCharge.mutations,
		...updatePartCharge.mutations,
	},
	actions: {
		...getPartCharge.actions,
		...updatePartCharge.actions,
	},
};
